import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asDialog } from '../Common/Decorators';
import { ModuleDialogs } from '../../constants/Dialogs';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import { closeDialog } from '../../actions/DialogActionCreator';
import FullscreenDialog from '../Common/FullscreenDialog';
import Iframe from '../Common/Iframe';
import LRS from '../../utils/LRS';
import PopupWindow from '../Common/PopupWindow';

const styles = {
    fullscreenDialog: {
        appBarStyle: {
            background: 'rgb(39,134,125)'
        }
    }
};

const onCloseDialog = ({tinCanId}) => {
    LRS.getRegistrationActivity(tinCanId);
};

const ElearningPlayerDialog = ({open, draft, moduleId, asPopup = false, title = 'E-learning', onClose = onCloseDialog}) => (moduleId === draft.moduleId) && (
    <FullscreenDialog
        open={open === ModuleDialogs.ELEARNING_DIALOG}
        actionButton={<IconButton label="Close" onTouchTap={ () => {  onClose(draft); closeDialog(); } } ><CloseIcon/></IconButton>}
        title={title}
        {...styles.fullscreenDialog}
    >
        <div style={{ height: '95%'}}>
            {draft.launchUrl && ((asPopup || draft.asPopup)
                ?  (
                    <PopupWindow src={draft.launchUrl} >
                        {(windowClosed) => windowClosed ? <div>The media has finished, you can close the dialog.</div> : <div>The e-learning module is running in a popup window...</div>}
                    </PopupWindow>
                )
                : <Iframe src={draft.launchUrl} />
            )}
        </div>
    </FullscreenDialog>
);

ElearningPlayerDialog.propTypes = {
    moduleId: PropTypes.number.isRequired,
    open: PropTypes.string,
    draft: PropTypes.shape({
        launchUrl: PropTypes.string.isRequired,
        tinCanId: PropTypes.string,
        reset: PropTypes.bool,
    }),
    title: PropTypes.string,
    onClose: PropTypes.func
};

export default asDialog(ElearningPlayerDialog, ModuleDialogs.ELEARNING_DIALOG);
